import Box from "@memorang/ui/components/Box";
import CopyButton from "@memorang/ui/components/CopyButton";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { Card, Divider, Text } from "react-native-paper";

export type ContactSupportProps = {
	supportEmail: string;
	subject: string;
	body: string;
	appName: string;
	platform: string;
	version?: string;
};

export const ContactSupport = ({
	supportEmail,
	subject,
	body,
	appName,
	platform,
	version,
}: ContactSupportProps) => {
	const theme = useAppTheme();

	const copyText = `${supportEmail}

${subject}

${body}`;

	return (
		<Card mode="elevated" style={{ overflow: "hidden" }}>
			<Card.Title
				title={<Text variant="titleLarge">Support Information</Text>}
				right={() => <CopyButton text={copyText} size={20} />}
			/>
			<Divider style={{ backgroundColor: theme.colors.surfaceVariant }} />

			<Card.Content>
				<Box
					style={{
						paddingVertical: 16,
					}}
				>
					<Box style={{ flexDirection: "column", gap: 12 }}>
						<Box style={{ flexDirection: "column", gap: 2 }}>
							<Text variant="labelMedium" style={{ opacity: 0.7 }}>
								Email
							</Text>
							<Text variant="bodyLarge" style={{ fontWeight: "600" }}>
								{supportEmail}
							</Text>
						</Box>

						<Box style={{ flexDirection: "column", gap: 2 }}>
							<Text variant="labelMedium" style={{ opacity: 0.7 }}>
								Subject
							</Text>
							<Text
								variant="bodyMedium"
								style={{ fontWeight: "500" }}
								numberOfLines={2}
							>
								{subject}
							</Text>
						</Box>
					</Box>
				</Box>

				<Divider style={{ backgroundColor: theme.colors.surfaceVariant }} />

				<Box
					style={{
						paddingVertical: 16,
						gap: 8,
					}}
				>
					<Text variant="labelMedium" style={{ opacity: 0.7 }}>
						Message Body
					</Text>
					<Box
						style={{
							padding: 16,
							borderRadius: theme.roundness,
							minHeight: 80,
							backgroundColor: theme.colors.elevation.level5,
						}}
					>
						<Text variant="bodyMedium" style={{ lineHeight: 20 }}>
							{body}
						</Text>
					</Box>
				</Box>

				<Divider style={{ backgroundColor: theme.colors.surfaceVariant }} />

				<Box
					style={{
						paddingVertical: 16,
						gap: 8,
					}}
				>
					<Text variant="labelMedium" style={{ opacity: 0.7 }}>
						App Details
					</Text>
					<Box
						style={{
							flexDirection: "row",
							flexWrap: "wrap",
							marginHorizontal: -8,
							gap: 16,
						}}
					>
						<Box
							style={{
								paddingHorizontal: 8,
							}}
						>
							<Box style={{ gap: 2 }}>
								<Text variant="labelSmall" style={{ opacity: 0.8 }}>
									Name
								</Text>
								<Text
									variant="bodyMedium"
									style={{ fontWeight: "500" }}
									numberOfLines={1}
								>
									{appName}
								</Text>
							</Box>
						</Box>

						{!!version && (
							<Box
								style={{
									paddingHorizontal: 8,
								}}
							>
								<Box style={{ gap: 2 }}>
									<Text variant="labelSmall" style={{ opacity: 0.8 }}>
										Version
									</Text>
									<Text variant="bodyMedium" style={{ fontWeight: "500" }}>
										{version}
									</Text>
								</Box>
							</Box>
						)}

						<Box
							style={{
								paddingHorizontal: 8,
							}}
						>
							<Box style={{ gap: 2 }}>
								<Text variant="labelSmall" style={{ opacity: 0.8 }}>
									Platform
								</Text>
								<Text variant="bodyMedium" style={{ fontWeight: "500" }}>
									{platform}
								</Text>
							</Box>
						</Box>
					</Box>
				</Box>
			</Card.Content>
		</Card>
	);
};
